// extracted by mini-css-extract-plugin
module.exports = {"map":"RetailerMap_map__v5iKD","iconContainer":"RetailerMap_iconContainer__3-hLp","icon":"RetailerMap_icon__3_wUT","iconSmall":"RetailerMap_iconSmall__3LHxR"};